import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sixoneimportlandproc',
  templateUrl: './sixoneimportlandproc.component.html',
  styleUrls: ['./sixoneimportlandproc.component.css']
})
export class SixoneimportlandprocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landprocurement/sixoneimportlandproc/sixoneimportlandproc.component.ts